import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'era-page-error',
  templateUrl: './page-error.component.html',
  styleUrls: ['./page-error.component.scss'],
})
export class PageErrorComponent {
  @HostBinding('class') hostClass = 'd-flex w-100';
}
